import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateStatus',
  standalone:false
})
export class TranslateStatusPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: string): string {
    const statusKey = `PAYMENT.STATUS.${value}`;
    const translated = this.translate.instant(statusKey);
    return translated === statusKey ? value : translated;
  }
}